// Hero.jsx

import React from 'react';
// import React, { useState, useEffect } from 'react';
import { Award, TrendingUp, Shield } from 'lucide-react';
// import { ChevronLeft, ChevronRight, Leaf, Award, Globe, TrendingUp, Users, Shield } from 'lucide-react';
import '../styles/hero.css';
import livelogo from '../assets/images/logo-gif.gif';
// import coffeeBg1 from '../assets/images/coffee-bg_1.jpeg';
// import coffeeBg2 from '../assets/images/coffee-bg_2.jpeg';
// import coffeeBg3 from '../assets/images/coffee-bg_3.jpeg';
import { Link } from "react-router-dom";
import farmingImg1 from '../assets/images/Real_Farming_1.jpg';
import farmingImg2 from '../assets/images/Real_Farming_2.jpg';
import farmingImg3 from '../assets/images/Real_Farming_3.jpg';
import heroVideo from '../assets/videos/hero-farm.mp4';


export default function Hero() {
  // const [currentSlide, setCurrentSlide] = useState(0); 

  const slides = [ 
    {
      video: heroVideo,
      title: "Premium Coffee Beans",
      subtitle: "Exporting Worldwide"
    },
    // {
    //   image: coffeeBg1,
    //   title: "Premium Coffee Beans",
    //   subtitle: "Exporting  Worldwide"
    // },
    // {
    //   image: coffeeBg2,
    //   title: "Sustainable Farming",
    //   subtitle: "From Our Estates"
    // },
    // {
    //   image: coffeeBg3,
    //   title: "Global Excellence",
    //   subtitle: "Trusted Worldwide"
    // }
  ];

  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     setCurrentSlide((prev) => (prev + 1) % slides.length);
  //   }, 5000);
  //   return () => clearInterval(timer);
  // }, []);

  // const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % slides.length);
  // const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);

  return (
    <div className="hero-page">
            {/* SECTION 1: VIDEO HERO (looping video, old image slider kept in comments) */}
      <section className="luxury-slider">
        {slides.map((slide, index) => (
          <div
            key={index}
            className="slide active"
            // className={`slide ${index === currentSlide ? 'active' : ''}`}
          >
            <video
              className="slide-image"
              src={slide.video}
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
            />
            {/* <img src={slide.image} alt={slide.title} className="slide-image" /> */}

            <div className="slide-overlay">
              <div className="slide-content">
                <img src={livelogo} alt="Aditya Logo" className="hero-logo-small" />

                <h1 className="hero-title">
                  INDIAN GREEN COFFEE BEANS<br />
                  Exporting Worldwide
                </h1>

                <p className="hero-desc-top">
                  From Indian coffee plantations to global markets —
                  <span className="brand-bold"> ADITYA EXPORTS VENTURES </span>
                  delivers quality you can trust.
                </p>

                <p className="hero-desc-bottom">
                  We specialize in sourcing, processing, and exporting high-quality
                  coffee beans with international standards, reliable logistics, and
                  transparent trade practices.
                </p>

                <div className="hero-action-btns">
                  {/* <button className="btn-coffee-primary">
                    Explore Our Coffee
                  </button> */}
                  <Link to="/coffee/green" className="btn-coffee-primary">
                    Explore Our Coffee
                  </Link>

                  {/* <button className="btn-coffee-outline">
                    Get Export Quote
                  </button> */}
                  <Link to="/contact#contact-form" className="btn-coffee-outline">
                    Get Export Quote
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* OLD ARROWS AND DOTS (hidden, only one slide now)
        <div className="slider-controls">
          <button className="slider-btn" onClick={prevSlide}>
            <ChevronLeft size={24} />
          </button>
          <button className="slider-btn" onClick={nextSlide}>
            <ChevronRight size={24} />
          </button>
        </div>

        <div className="slider-dots">
          {slides.map((_, index) => (
            <div
              key={index}
              className={`dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
        */}
      </section>

      {/* SECTION 2: REAL FARMING */}
      <section className="real-farming">
        <div className="farming-container">
          <div className="farming-header">
            <span className="section-label">Real Farming</span>
            <h2 className="section-title">From Our Estates to Your Cup</h2>
            <p className="farming-intro">
              Our coffee journey begins in the lush plantations of South India, where 
              generations of expertise meet modern sustainable practices.
            </p>
          </div>

          <div className="farming-grid">
            <div className="farming-card">
              <div className="farming-image-wrapper">
                <img 
                  src={farmingImg1}
                  alt="Coffee Plantation" 
                  className="farming-image"
                />
                {/* <div className="farming-overlay">
                  <Leaf size={32} color="#ffffff" />
                </div> */}
              </div>
              <div className="farming-card-content">
                <h3>Precision Harvesting</h3>
                <p>Each cherry is chosen at peak maturity, preserving sweetness, aroma, and true estate-grown character.</p>
              </div>
            </div>

            <div className="farming-card">
              <div className="farming-image-wrapper">
                <img 
                  src={farmingImg2}
                  alt="Coffee Cherries" 
                  className="farming-image"
                />
                {/* <div className="farming-overlay">
                  <Users size={32} color="#ffffff" />
                </div> */}
              </div>
              <div className="farming-card-content">
                <h3>On-Field Inspection</h3>
                <p>Careful monitoring of ripe coffee cherries directly at the plantation ensures quality from the very first step.</p>
              </div>
            </div>

            <div className="farming-card">
              <div className="farming-image-wrapper">
                <img 
                  src={farmingImg3}
                  alt="Coffee Processing" 
                  className="farming-image"
                />
                {/* <div className="farming-overlay">
                  <Award size={32} color="#ffffff" />
                </div> */}
              </div>
              <div className="farming-card-content">
                <h3>Beans Quality Checks</h3>
                <p>Premium Green Coffee Beans undergoing strict quality checks to ensure purity, freshness, and consistency at every stage.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 3: ABOUT US - THE PILLARS */}
      <section className="about-pillars">
        <div className="pillars-container">
          <div className="pillars-header">
            <span className="section-label">About Us</span>
            <h2 className="pillars-title">Built on Three Pillars</h2>
            <p className="pillars-subtitle">
              Our commitment to excellence is founded on quality, vision, and trust
            </p>
          </div>

          <div className="pillars-grid">
            <div className="pillar-box">
              <div className="pillar-icon">
                <Award size={40} />
              </div>
              <h3 className="pillar-title">QUALITY</h3>
              <p className="pillar-description">
                Uncompromising standards from farm to export. Every batch undergoes 
                rigorous testing and quality control, ensuring only premium beans 
                reach international markets. ISO certified and globally recognized.
              </p>
            </div>

            <div className="pillar-box">
              <div className="pillar-icon">
                <TrendingUp size={40} />
              </div>
              <h3 className="pillar-title">VISION</h3>
              <p className="pillar-description">
                To be the most trusted name in Indian coffee exports, bridging 
                traditional farming excellence with modern global trade. We're 
                building lasting relationships that span continents.
              </p>
            </div>

            <div className="pillar-box">
              <div className="pillar-icon">
                <Shield size={40} />
              </div>
              <h3 className="pillar-title">WHY US</h3>
              <p className="pillar-description">
                Established in 2025, Aditya Exports Ventures is an emerging Indian export company
              focused on supplying quality agricultural commodities to international markets.
              We specialize in sourcing premium coffee beans directly from trusted farms and
              processing units across India.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4: CTA - THE CLOSER */}
      <section className="cta-section">
        <div className="cta-container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Experience Premium Indian Coffee?</h2>
            <p className="cta-description">
              Connect with our export team to discuss your requirements and receive a customized quote
            </p>
            <div className="cta-buttons">
              {/* <button className="btn-cta-primary">
                Request Export Quote
              </button> */}
              <Link to="/coffee/green" className="btn-cta-primary">
                Explore Our Products
              </Link>

              {/* <button to="/contact#contact-form" className="btn-cta-outline">
                Explore Our Products
              </button> */}
              <Link to="/contact#contact-form" className="btn-cta-outline">
                Request Export Quote
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}